var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgVirtualClassroom = function SvgVirtualClassroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 46"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h43v4H0zm0 24.667h43v4H0zm3.583-20h35.833v20H3.583z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M21.142 29.1v7.8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.142,
    cy: 41,
    rx: 3.225,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.917 10l6.45 4.754-6.45 4.579"
  }))));
};
export default SvgVirtualClassroom;